module.exports = __webpack_public_path__ + "img/13.a9e49082.jpg";